import { z } from 'zod';

const ctaSchema = z
  .object({
    cta_title: z.string().optional(),
    cta_link: z.string().optional(),
  })
  .partial();

const notificationDataSchema = z
  .object({
    cta: ctaSchema.nullable().optional(),
    link: z.string().nullable().optional(),
    nodeId: z.string().nullable().optional(),
    exportId: z.string().nullable().optional(),
    name: z.string().nullable().optional(),
    commentId: z.string().nullable().optional(),
    replyId: z.string().nullable().optional(),
    shareId: z.string().nullable().optional(),
    expiredAt: z.string().nullable().optional(),
    nodeType: z.string().nullable().optional(),
    title: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
  })
  .passthrough();

const rawNotificationSchema = z
  .object({
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().nullable().optional(),
    readAt: z.string().nullable().optional(),
    link: z.string().nullable().optional(),
    cta: ctaSchema.nullable().optional(),
    type: z.string().optional(),
    nodeType: z.string().optional(),
    exportId: z.string().nullable().optional(),
    notifiableType: z.string().optional(),
    notifiableId: z.string().optional(),
    commentId: z.string().nullable().optional(),
    replyId: z.string().nullable().optional(),
    data: z
      .union([notificationDataSchema, z.array(z.any())])
      .nullable()
      .optional(),
  })
  .strip();

export const notificationSchema = rawNotificationSchema.transform((notification) => {
  const { data, ...notificationWithoutData } = notification;
  const payload = data && !Array.isArray(data) ? data : undefined;

  return {
    ...payload,
    ...notificationWithoutData,
    cta: notificationWithoutData.cta ?? payload?.cta,
    title: notificationWithoutData.title ?? payload?.title ?? '',
    description: notificationWithoutData.description ?? payload?.description ?? '',
    createdAt: notificationWithoutData.createdAt ?? '',
    updatedAt: notificationWithoutData.updatedAt,
    readAt: notificationWithoutData.readAt ?? null,
  };
});

export type Notification = z.infer<typeof notificationSchema>;

const notificationsPaginationSchema = z.object({
  offset: z.number(),
  limit: z.number(),
  count: z.number(),
});
export const notificationsArraySchema = z.array(notificationSchema);

export const markAllNotificationsAsReadResponse = z.object({
  notifications: notificationsArraySchema,
});

export const notificationsResponseSchema = z.object({
  notifications: notificationsArraySchema,
  unreadCount: z.number().default(0),
  pagination: notificationsPaginationSchema,
});

export type NotificationsResponse = z.infer<typeof notificationsResponseSchema>;
